// Regex matching the start of any valid mermaid diagram type
export const MERMAID_START =
  /^\s*(flowchart|graph\s+(TD|LR|TB|BT|RL)|sequenceDiagram|classDiagram|stateDiagram(-v2)?|erDiagram|gantt|pie|gitGraph|journey|mindmap|timeline|requirementDiagram|C4Context|C4Container|C4Component|C4Dynamic|block-beta|xychart-beta|sankey-beta|packet-beta)/i;

let mermaidInitialized = false;

async function getMermaid() {
  const mermaid = (await import('mermaid')).default;
  if (!mermaidInitialized) {
    mermaid.initialize({ startOnLoad: false, theme: 'neutral' });
    mermaidInitialized = true;
  }
  return mermaid;
}

const processed = new WeakSet<Element>();

// requireMermaidSyntax guards callers that scan generic code blocks without a language marker
// (e.g. TechDocs pygments output); callers that already know the block is mermaid (e.g. the
// Qeta rehype plugin, which only marks `language-mermaid` blocks) can skip that check.
export async function renderMermaidCandidates(
  candidates: Element[],
  requireMermaidSyntax = true,
) {
  const toRender = candidates.filter(el => !processed.has(el));
  if (!toRender.length) return;

  const mermaid = await getMermaid();

  for (const el of toRender) {
    processed.add(el);

    const source = el.textContent?.trim() ?? '';
    if (!source) continue;
    if (requireMermaidSyntax && !MERMAID_START.test(source)) continue;

    try {
      const id = `mermaid-${Math.random().toString(36).slice(2, 10)}`;
      const { svg } = await mermaid.render(id, source);

      // Replace the outermost block container (div.highlight or pre) with the SVG
      const container =
        el.closest('div.highlight') ??
        el.closest('table.highlighttable')?.closest('div') ??
        el.closest('pre') ??
        el;

      const div = document.createElement('div');
      div.style.cssText = 'overflow:auto;text-align:center;margin:1em 0';
      div.innerHTML = svg;
      container.replaceWith(div);
    } catch {
      // leave raw text visible if mermaid fails to parse
    }
  }
}
